/* ITA2-1283 (part 2, v3) — per-product price correction for the XCloud app's
   instant-search widget.
   Why: the widget prices rows as indexed-base-USD x one FX rate. italist's
   market prices are PER-PRODUCT (pricing rules vary by brand/product), so no
   single rate can be right — verified live: two Gucci bags off in opposite
   directions. The only correct display is each product's own live Markets
   price, which IT7FX.quote() already provides (same source as the PDP).
   How: (1) a read-only XMLHttpRequest tap (the widget uses XHR, not fetch)
   captures its suggest responses and stores result-index -> product-handle
   maps KEYED BY QUERY (the widget re-renders cached queries with no network
   call, so the map must follow the query text, never "latest response");
   (2) a MutationObserver rewrites each price node (stable ids
   "cloud-search-option-<i>-price") plus the .cs-list-price compare-at from
   IT7FX.quote(), house-formatted — but only when the search input's current
   value matches a stored query, so rows can never be paired with another
   query's products. Every failure path leaves the widget's own rendering
   untouched. The Shopify.currency.rate shim below remains as the baseline
   for anything the rewrite doesn't cover. */
(function () {
  'use strict';
  if (window.__it7xc) return; window.__it7xc = 1;

  /* ── per-product rewrite ─────────────────────────────────────────── */
  var maps = {}; /* normalized query -> [handles by result index] */
  var norm = function (s) { return String(s || '').trim().toLowerCase(); };

  var O = XMLHttpRequest.prototype.open, S = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__it7u = String(u || ''); return O.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this, u = x.__it7u || '';
    if (u.indexOf('cloudsearchapp.com') > -1 && u.indexOf('q=') > -1) {
      x.addEventListener('load', function () {
        try {
          var q = norm(new URL(u, location.href).searchParams.get('q'));
          var d = JSON.parse(x.responseText);
          if (q && d && Array.isArray(d.products)) {
            maps[q] = d.products.map(function (p) {
              return (p.url || '').split('?')[0].split('/products/')[1] || null;
            });
            schedule();
          }
        } catch (e) {}
      });
    }
    return S.apply(this, arguments);
  };

  function activeMap() {
    var inp = document.activeElement;
    if (!inp || inp.tagName !== 'INPUT') {
      inp = document.querySelector('input[type="search"], input[aria-label*="earch"]');
    }
    return inp ? maps[norm(inp.value)] : null;
  }

  function sweep() {
    if (!window.IT7FX || !IT7FX.quote) return;
    var map = activeMap();
    if (!map) return;
    document.querySelectorAll('[id^="cloud-search-option-"][id$="-price"]:not([data-it7q])').forEach(function (n) {
      var m = /cloud-search-option-(\d+)-price/.exec(n.id || '');
      if (!m) return;
      var h = map[parseInt(m[1], 10)];
      if (!h) return;
      n.setAttribute('data-it7q', '1');
      IT7FX.quote(h).then(function (q) {
        if (!q || !q.price) return;
        n.textContent = IT7FX.format(q.price);
        var b = n.parentElement, l = b && b.querySelector('.cs-list-price');
        if (l && l !== n) {
          if (q.compareAt && q.compareAt > q.price) l.textContent = IT7FX.format(q.compareAt);
          else l.remove();
        }
      }).catch(function () {});
    });
  }
  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(sweep, 60); }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });

  /* ── baseline: truthful Shopify.currency.rate (blended, once learned) ── */
  function install() {
    if (!window.Shopify || !Shopify.currency) return false;
    var d = Object.getOwnPropertyDescriptor(Shopify.currency, 'rate');
    if (d && d.get) return true;
    var orig = Shopify.currency.rate;
    try {
      Object.defineProperty(Shopify.currency, 'rate', {
        configurable: true, enumerable: true,
        get: function () {
          try {
            if (window.IT7FX && IT7FX.presentment && IT7FX.rate && IT7FX.rate !== 1) return String(IT7FX.rate);
          } catch (e) {}
          return orig;
        },
        set: function (v) { orig = v; }
      });
    } catch (e) { return false; }
    return true;
  }
  if (!install()) {
    var tries = 0;
    var iv = setInterval(function () { if (install() || ++tries > 50) clearInterval(iv); }, 200);
  }
})();
